// src/components/TourManager.js 

import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Joyride, { STATUS } from "react-joyride";
import { tours } from "../tours";

export default function TourManager() {
  const location = useLocation();
  const [runTour, setRunTour] = useState(false); // O tour começa com o estado "parado"
  const [steps, setSteps] = useState([]);

  // Agora, este useEffect apenas carrega os passos corretos para a página atual.
  // Ele não inicia mais o tour.
  useEffect(() => {
    const path = location.pathname;
    const nextSteps = tours[path] || [];
    setSteps(nextSteps);
  }, [location.pathname]);

  const handleJoyrideCallback = ({ status }) => {
    // Quando o tour termina (finalizado ou pulado), garantimos que ele pare.
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setRunTour(false);
      // Opcional: você pode decidir se quer marcar como "feito" mesmo se o usuário só clicou para abrir e fechar.
      // Se quiser marcar como feito apenas ao completar, mova esta linha para dentro de um if (status === STATUS.FINISHED).
      localStorage.setItem(`tourDone:${location.pathname}`, "true");
    }
  };

  // Se não houver passos para esta rota, não renderiza nada (nem o ícone).
  if (steps.length === 0) {
    return null;
  }

  return (
    <>
      {/* Ícone de ajuda flutuante */}
      <div
        style={{
          position: "fixed",
          top: 100,
          right: 20,
          cursor: "pointer",
          zIndex: 1000,
        }}
        aria-label="Abrir tour"
        role="button"
        // O onClick agora é a ÚNICA maneira de iniciar o tour.
        onClick={() => setRunTour(true)}
      >
        <i
          className="ri-question-line"
          style={{ fontSize: "36px", color: "#0ad6a0" }}
        />
      </div>

      {/* Joyride */}
      <Joyride
        steps={steps.map((s) => ({ ...s, disableBeacon: true }))}
        run={runTour} // O tour só roda quando runTour é true
        continuous
        showSkipButton
        styles={{
          options: { primaryColor: "#0ad6a0", zIndex: 1000 },
        }}
        locale={{
          skip: "Pular",
          next: "Próximo",
          back: "Voltar",
          last: "Finalizar",
        }}
        callback={handleJoyrideCallback}
      />
    </>
  );
}